import * as React from 'react';
import { FileFieldCore } from '@core-front/filefield';
import Anchor from '@telia-front/anchor';
import Button from '@telia-front/button';
import Chip from '@telia-front/chip';
import FormHelper from '@telia-front/form-helper';
import List, { ListItem } from '@telia-front/list';
const FileField = (props) => {
    return (React.createElement(FileFieldCore, Object.assign({}, props, { components: {
            Anchor,
            Button,
            Chip,
            FormHelper,
            List,
            ListItem,
        } })));
};
export { FileField as default };
